import { render, staticRenderFns } from "./loginLayer.vue?vue&type=template&id=5842efed&scoped=true&"
import script from "./loginLayer.vue?vue&type=script&lang=js&"
export * from "./loginLayer.vue?vue&type=script&lang=js&"
import style0 from "./loginLayer.vue?vue&type=style&index=0&id=5842efed&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842efed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/home/chofn/components/SvgIcon.vue').default})
